import { pathnameToBackLink, pathnameToText } from '@components/layout/top-bar/data';
import { ArrowBack } from '@mui/icons-material';
import { Grid, IconButton, Typography } from '@mui/material';
import { RootState } from '@redux/store';
import { navigateTo } from '@services/navigation';
import React from 'react';
import { useSelector } from 'react-redux';

export default function HeadingArrowWrapper({
  title = '',
  sx = {},
  disableBack = false,
  children = null,
  backButtonOnClick = null
}: {
  title: string,
  sx?: any,
  disableBack?: boolean,
  children?: React.ReactNode | null,
  backButtonOnClick?: null | ((x: any) => void)
}) {
  const { searchedQuery } = useSelector((s: RootState) => s.misc);
  const linkToRedirect = pathnameToBackLink(window.location.pathname, searchedQuery?.link);
  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      sx={{
        borderRadius: '8px',
        margin: '1em',
        flexWrap: 'nowrap',
        paddingTop: '1em !important',
        ...sx
      }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{
          borderRadius: '8px',
          flexWrap: 'nowrap'
        }}>
        {disableBack ? null : pathnameToText(window.location.pathname) ===
          ' ' ? null : linkToRedirect === null ? null : (
          <Grid item>
            <IconButton
              color="inherit"
              // edge="end"
              onClick={() => {
                if (backButtonOnClick) {
                  backButtonOnClick(() => {
                    navigateTo(linkToRedirect);
                  });
                } else {
                  navigateTo(linkToRedirect);
                }
              }}
              sx={{ height: '2.8rem', width: '2.8rem', backgroundColor: '#F5F5F5', mr: '1rem' }}
              data-cy="back">
              <ArrowBack />
            </IconButton>
          </Grid>
        )}
        <Grid item xs={linkToRedirect !== null ? 11 : 12}>
          <Typography
            variant="body1"
            sx={{
              margin: 0,
              fontWeight: 600,
              textAlign: 'left',
              fontFamily: 'Poppins'
            }}>
            {title}
          </Typography>
        </Grid>
      </Grid>
      {children}
    </Grid>
  );
}
